import { ChangeDetectionStrategy, Component, effect, ElementRef, HostListener, inject, signal } from '@angular/core'
import { Router } from '@angular/router'
import { UserInterface } from '@ui-core/interfaces/user.interface'
import { MenuService } from '@ui-core/services/menu.service'
import { ThemeService } from '@ui-core/services/theme.service'
import { UserService } from '@ui-core/services/user.service'
import { MenuItem } from 'primeng/api'

@Component({
    selector: 'app-menu',
    templateUrl: './menu.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Menu {
    private elementRef = inject(ElementRef)
    private menuService = inject(MenuService)
    private router = inject(Router)
    private themeService = inject(ThemeService)
    private userService = inject(UserService)

    userItems = signal<MenuItem[] | null>(null)
    userInfo = signal<UserInterface | null>(null)
    isUserMenuVisible = signal(false)

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: Event): void {
        const clickedInside = this.elementRef.nativeElement.contains(event.target)
        if (!clickedInside) {
            this.isUserMenuVisible.set(false)
        }
    }

    constructor() {
        this.themeService.initializeTheme()

        effect(() => {
            const user = this.userService.get()()
            if (user) {
                this.userInfo.set(user)
            }
        })

        effect(() => {
            const menu = this.menuService.getUserMenu()()
            if (menu) {
                this.userItems.set(menu)
            }
        })
    }

    goTo(path: string): void {
        this.router.navigate([path])
    }

    logout(): void {
        this.userService.setLogout(true)
    }
}
